// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3QSER","inner":"Footer_inner__12DY_","nextIcon":"Footer_nextIcon__1t6SV","innerLeft":"Footer_innerLeft__G6WB7"};